import React from "react";
import { Link } from "react-router-dom";
import ScrollReveal from "@/components/ScrollReveal";

/**
 * Final-CTA strip with full-bleed photo, eyebrow, headline + italic tail,
 * subtitle, and a brass-bordered button. Used on Home + detail bottoms.
 */
export default function CTAStrip({
  eyebrow,
  headline,
  italicTail,
  subtitle,
  buttonLabel,
  buttonTo,
  image,
  imageAlt = "",
}) {
  return (
    <section
      data-testid="cta-strip-section"
      className="relative w-full overflow-hidden text-ivory"
      style={{ minHeight: "65vh" }}
    >
      {image && (
        <img src={image} alt={imageAlt} className="absolute inset-0 w-full h-full object-cover cta-kb" loading="lazy" decoding="async" />
      )}
      <div
        className="absolute inset-0"
        style={{
          background: "linear-gradient(180deg, rgba(26,26,26,0.55) 0%, rgba(26,26,26,0.45) 50%, rgba(26,26,26,0.65) 100%)",
        }}
        aria-hidden
      />
      <div className="relative z-10 mx-auto max-w-3xl px-6 md:px-10 py-24 md:py-32 text-center">
        <ScrollReveal>
          <p className="eyebrow text-brass">{eyebrow}</p>
        </ScrollReveal>
        <ScrollReveal delay={140}>
          <h2
            className="font-display text-ivory mt-6 leading-[1.05] text-balance"
            style={{ fontSize: "clamp(2.25rem, 5vw, 3.5rem)" }}
          >
            {headline}{" "}
            {italicTail && (
              <span className="italic-quote" style={{ fontWeight: 400 }}>
                {italicTail}
              </span>
            )}
          </h2>
        </ScrollReveal>
        {subtitle && (
          <ScrollReveal delay={240}>
            <p className="italic-quote text-ivory/85 mt-5 text-balance" style={{ fontSize: "clamp(1.1rem, 1.4vw, 1.35rem)" }}>
              {subtitle}
            </p>
          </ScrollReveal>
        )}
        <ScrollReveal delay={340}>
          <Link to={buttonTo} className="btn-brass text-ivory mt-10 inline-flex">
            {buttonLabel}
          </Link>
        </ScrollReveal>
      </div>
    </section>
  );
}
